import { render, staticRenderFns } from "./LegalDocumentContent_qnEiAd.vue?vue&type=template&id=3e0c01ed&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_qnEiAd.vue?vue&type=style&index=0&id=3e0c01ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c01ed",
  null
  
)

export default component.exports